export default __webpack_public_path__ + "static/media/idatascience-white.0650ab68.svg";